module.exports = __webpack_public_path__ + "img/logo8@2x.181ee790.png";